<template>
    <el-row :gutter="20"     style="padding: 30px;min-height: 800px;">
        <h1 class="title">客服中心</h1>

        <div class="subtitle"><i class="el-icon-star-on"></i>微信公众号</div>
        <div class="subcontent">关注《1701账号服务》微信公众号，可直接发送您要咨询的内容。</div>
        <img src="../../../assets/img/gzh.jpg" class="gzh" />
       
        <div class="subtitle"><i class="el-icon-star-on"></i>客服微信</div>
        <img src="../../../assets/img/cs.png" class="cs" />
      

        <div class="subtitle"><i class="el-icon-star-on"></i>客服热线</div>
        <div class="subcontent">0571-87099901</div>
       


    </el-row>

</template>

<script>


export default {
    name: "guide1",
    data() {
        return {

        };
    },
    components: {

    },
    computed: {

    },
    created() {

    },
    activated() {

    },
    deactivated() {

    },
    methods: {


    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.title {
    font-size: 32px;
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: 400;
    color: #ff8800;
}

.subtitle {
    font-size: 20px;
    line-height: 60px;
    font-weight: 400;
   
}

.subcontent {
    font-size: 18px;
    line-height: 30px;
    color: rgb(124, 124, 124);
    padding-left: 20px;
    margin-bottom: 20px;
}

.el-icon-star-on {
    color: #ffa01b;
}

.gzh{
    margin-left: 30px;
}

.cs
{
    width: 250px;
    margin-left: 30px;
}

</style>
